export default __webpack_public_path__ + "assets/Info_icon.svg";